import axios from 'axios';
import * as constants from '../utility/BaseConstants';
import Cookies from 'js-cookie';

class UsersService{

    getUsers(){
        const token = Cookies.get("token");
        const headers = token ? { Authorization: token } : {};
        return axios.get(`${constants.API_BASE_URL}${constants.USERS_END_POINT.ALL_USERS}`, { headers });
    }

    checkPhoneExists(phone_no){
        return axios.get(`${constants.API_BASE_URL}${constants.USERS_END_POINT.PHONE_EXISTS}`+phone_no);
    }

    checkEmailExists(email){
        return axios.get(`${constants.API_BASE_URL}${constants.USERS_END_POINT.EMAIL_EXISTS}`+email);

    }

        validateLogin(phone_no, password, accountType) {
                const type = (accountType || "").toLowerCase();
                const loginPath =
                        type === "college"
                                ? "college/login"
                                : type === "admin"
                                ? "admin/login"
                                : type === "author"
                                ? "author/login"
                                : type === "student"
                                ? "student/login"
                                : constants.USERS_END_POINT.GET_LOGIN_RESPONSE;

                return axios.post(`${constants.API_BASE_URL}${loginPath}`,
                    {
                        phoneNo: phone_no,
                        password: password,
                    }
                );
        }

    validateSignup(user) {
        return axios.post(`${constants.API_BASE_URL}${constants.USERS_END_POINT.GET_SIGNUP_RESPONSE}`,user);
    }

    validateGoogleLogin(idToken, accountType, phoneNo) {
        return axios.post(`${constants.API_BASE_URL}google`, {
            idToken,
            accountType,
            ...(phoneNo ? { phoneNo } : {}),
        });
    }

    // Mobile OTP login. `config` says whether the admin has switched it on (and the SMS gateway
    // is complete); the popup only offers the option when it comes back enabled.
    getOtpLoginConfig() {
        return axios.get(`${constants.API_BASE_URL}otp/config`);
    }

    sendLoginOtp(phoneNo, accountType) {
        return axios.post(`${constants.API_BASE_URL}otp/send`, { phoneNo, accountType });
    }

    verifyLoginOtp(phoneNo, otp, accountType) {
        return axios.post(`${constants.API_BASE_URL}otp/verify`, { phoneNo, otp, accountType });
    }
}

export default new UsersService;